import { styled } from '@grupoboticario/flora-react';

import { Divider } from 'components';

const styles = {
  Divider: styled(Divider, {
    backgroundColor: '$nonInteractiveAltAuxiliar',
    height: '2px',
  }),
};

export default styles;
